<template>
  <el-form ref="form" :model="Form" :rules="rules" class="addressForm" label-width="100px" label-position="left">
    <el-form-item label="收货人1:" prop="receiverName">
      <el-input v-model="Form.receiverName" placeholder="请输入收货人姓名" />
    </el-form-item>
    <el-form-item label="手机号1:" prop="receiverPhone">
      <el-input v-model="Form.receiverPhone" placeholder="请输入收货人手机号码" />
    </el-form-item>
    <el-form-item label="收货人2:" prop="secondRecipientName">
      <el-input v-model="Form.secondRecipientName" placeholder="请输入收货人姓名" />
    </el-form-item>
    <el-form-item label="手机号2:" prop="secondRecipientTel">
      <el-input v-model="Form.secondRecipientTel" placeholder="请输入收货人手机号码" />
    </el-form-item>
    <el-form-item label="收货人单位:" prop="receiverUnit">
      <el-input v-model="Form.receiverUnit" placeholder="请输入收货人单位" />
    </el-form-item>
    <el-form-item label="电子邮箱:" prop="email">
      <el-input v-model="Form.email" placeholder="请输入收货人电子邮箱" />
    </el-form-item>
    <el-form-item label="所在地区:" prop="citys">
      <el-cascader ref="cascader" v-model="Form.citys" :options="CityList" style="width: 100%" :props="cascaderProps" @visible-change="cascaderDef" />
    </el-form-item>
    <el-form-item label="详细地址:" prop="receiptAddress">
      <el-input v-model="Form.receiptAddress" placeholder="不需要重复填写省市区" />
    </el-form-item>
    <el-form-item label="搬运楼层:" prop="transportFloorCode">
      <el-select ref="transportFloor" v-model="Form.transportFloorCode" placeholder="请选择搬运楼层" style="width: 100%" @change="changetransportFloor">
        <el-option v-for="option in floor" :key="option.code" :label="option.name" :value="option.code" />
      </el-select>
    </el-form-item>
    <el-form-item label="地址标签:" prop="addressLabel">
      <el-select v-model="Form.addressLabel" placeholder="请选择地址标签" style="width: 100%">
        <el-option v-for="option in addressLabel" :key="option.code" :label="option.name" :value="option.code" />
      </el-select>
    </el-form-item>
    <el-form-item label="送货时间:" prop="deliveryTime">
      <el-radio-group v-model="Form.deliveryTime">
        <el-radio v-for="(delivery,index) in deliveryTime" :key="index" :label="delivery.code">
          {{ delivery.name }}
        </el-radio>
      </el-radio-group>
    </el-form-item>
    <el-checkbox v-model="Form.isDefault">
      设为默认收货地址
    </el-checkbox>
    <div style="text-align: center;margin-top: 15px">
      <el-button type="primary" :loading="loading" @click="submit">
        确认修改
      </el-button>
    </div>
  </el-form>
</template>
<script type="es6">
import { mapState, mapActions } from 'vuex';
import { saveReceiptAddressInfo } from '@/API';
import { checkExportCompliance } from '@/libs/exportCompliance';
export default {
  data () {
    var checkEmpty = (rule, value, callback) => {
      if (value.length !== 0) {
        const reg = /\S/;
        let result = reg.test(value);
        if (result) {
          callback();
        } else {
          callback(new Error());
        }
      } else {
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
      if (!value) {
        callback();
      } else {
        if (!mailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      }
    };
    return {
      cascaderFlag: true,
      cascaderProps: {
        value: 'regionName',
        label: 'regionName',
        lazy: true,
        lazyLoad: this.cascaderLazyLoad
      },
      Form: {
        citys: []
      },
      rules: {
        receiverName: [
          { required: true, message: '请输入收货人1姓名', trigger: 'blur' },
          { validator: checkEmpty, message: '请输入收货人1姓名', trigger: 'blur' }
        ],
        receiverUnit: [
          { required: true, message: '请输入收货人单位', trigger: 'blur' },
          { validator: checkEmpty, message: '请输入收货人单位', trigger: 'blur' }
        ],
        receiptAddress: [
          { required: true, message: '请输入收货详细地址', trigger: 'blur' },
          { validator: checkEmpty, message: '请输入收货详细地址', trigger: 'blur' }
        ],
        receiverPhone: [
          { required: true, message: '请输入收货人1电话', trigger: 'blur' },
          { validator: checkEmpty, message: '请输入收货人1电话', trigger: 'blur' }
        ],
        secondRecipientName: [
          { required: true, message: '请输入收货人2电话', trigger: 'blur' },
          { validator: checkEmpty, message: '请输入收货人2电话', trigger: 'blur' }
        ],
        secondRecipientTel: [
          { required: true, message: '请输入收货人2电话', trigger: 'blur' },
          { validator: checkEmpty, message: '请输入收货人2电话', trigger: 'blur' }
        ],
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],
        transportFloorCode: [
          { required: true, message: '请选择搬运楼层', trigger: 'change' }
        ],
        citys: [
          { required: true, message: '请选择所在区域', trigger: 'change' }
        ],
        addressLabel: [
          { required: true, message: '请选择地址标签', trigger: 'change' }
        ]
      },
      loading: false
    };
  },
  props: {
    address: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {
    ...mapState({
      CityList: state => state.enumeration.CityList,
      floor: state => state.enumeration.floor,
      addressLabel: state => state.enumeration.addressLabel,
      deliveryTime: state => state.enumeration.deliveryTime
    })
  },
  methods: {
    ...mapActions('enumeration', [
      'initCityList',
      'getProvinceListByNode',
      'initAddressLabel',
      'initFloor'
    ]),
    cascaderLazyLoad (node, resolve) {
      if (node.level) {
        if (this.cascaderFlag) {
          this.Form.citys = [];
          this.cascaderFlag = false;
        }
        this.getProvinceListByNode({ node, resolve });
      }
    },
    stripscript (s) {
      var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）&mdash;—|{}【】/_‘’+；：”“'。，、？]");
      var rs = '';
      for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      return rs;
    },
    submit () {
      this.$refs.form.validate().then(async () => {
        this.Form.province = this.Form.citys[0];
        this.Form.city = this.Form.citys[1];
        this.Form.county = this.Form.citys[2];
        this.Form.receiptAddress = this.stripscript(this.Form.receiptAddress);
        this.loading = true;
        const params = { ...this.Form, citys: undefined };
        const decision = await checkExportCompliance(this, {
          businessScene: 'RECEIPT_ADDRESS_SAVE',
          originalBizId: this.Form.id ? String(this.Form.id) : null,
          subjectNameList: [this.Form.receiverUnit],
          addressList: [this.Form.receiptAddress]
        });
        if (!decision.allowBusiness) {
          this.loading = false;
          return;
        }
        saveReceiptAddressInfo(params).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            this.$emit('editSuccess', {});
          }
        }).catch(() => {
          this.loading = false;
        });
      }).catch(() => {

      });
    },
    changetransportFloor () {
      this.$nextTick(() => {
        this.Form.transportFloorName = this.$refs.transportFloor.selectedLabel;
      });
    },
    initHanderData () {
      this.Form = {
        id: this.address.id,
        citys: [this.address.province, this.address.city, this.address.county],
        receiverUnit: this.address.receiverUnit,
        transportFloorCode: this.address.transportFloorCode,
        transportFloorName: this.address.transportFloorName,
        receiverName: this.address.receiverName,
        receiptAddress: this.address.receiptAddress,
        secondRecipientName: this.address.secondRecipientName,
        secondRecipientTel: this.address.secondRecipientTel,
        receiverPhone: this.address.receiverPhone,
        email: this.address.email,
        province: this.address.province,
        city: this.address.city,
        county: this.address.county,
        deliveryTime: this.address.deliveryTime,
        addressLabel: this.address.addressLabel,
        isDefault: this.address.isDefault
      };
      this.cascaderDef();
    },
    cascaderDef (val) {
      if (!val) {
        this.$nextTick(() => {
          if (this.Form.citys.length === 3) {
            this.$refs.cascader.presentText = `${this.Form.citys[0]} / ${this.Form.citys[1]} / ${this.Form.citys[2]}`;
            this.$refs.cascader.inputValue = `${this.Form.citys[0]} / ${this.Form.citys[1]} / ${this.Form.citys[2]}`;
          }
        });
      }
    }
  },
  mounted () {
    this.initFloor();
    this.initAddressLabel();
    this.initCityList();
    this.initHanderData();
  }
};
</script>
<style lang="scss">
  .addressForm{
    .el-form-item.is-required{
      .el-form-item__label{
        &:before{
          float: right;
          right: 4px;
        }
      }
    }
  }
</style>
